/**
 * Handles HTTP errors, specifically checking for 401 Unauthorized errors
 * and redirecting to the sign-in page if the user's session has expired.
 * 
 * @param {Response} response - The fetch Response object
 * @param {string} errorMessage - Optional custom error message
 * @throws {Error} - Throws an error if the response is not ok
 */
export const handleResponseError = async (response, errorMessage = null) => {
    if (!response.ok) {
        // Check for 401 Unauthorized (session expired/inactive)
        if (response.status === 401) {
            console.log('401 Unauthorized - Session expired. Redirecting to sign-in page...');

            // Redirect to sign-in page
            window.location.href = '/signin';

            // Throw error to stop further execution
            // throw new Error('Session expired. Redirecting to sign-in...');
        }

        // For other errors, throw with custom or default message
        const message = errorMessage || `HTTP error! status: ${response.status}`;
        // throw new Error(message);
    }

    return response;
};

/**
 * Wrapper for fetch that automatically handles 401 errors
 * 
 * @param {string} url - The URL to fetch
 * @param {RequestInit} options - Fetch options
 * @returns {Promise<Response>} - The fetch Response object
 */
export const fetchWithErrorHandling = async (url, options = {}) => {
    try {
        const response = await fetch(url, options);
        await handleResponseError(response);
        return response;
    } catch (error) {
        // Re-throw the error after handling
        throw error;
    }
};

/**
 * Handles errors in catch blocks, checking if it's a 401 error
 * 
 * @param {Error} error - The error object
 */
export const handle401Error = (error) => {
    // Check if the error message indicates a 401
    if (error.message && error.message.includes('401')) {
        console.log('401 Unauthorized detected in catch block. Redirecting to sign-in page...');

        // Clear any stored authentication data
        localStorage.removeItem('authToken');
        sessionStorage.clear();

        // Redirect to sign-in page
        window.location.href = '/signin';
    }
};
